import { doc, runTransaction } from "firebase/firestore";
import { v4 } from "uuid";
import application from "../core/application";
import firebase from "../core/firebase";
import { CustomerAccount } from "./customer-account.entity";
import { CreditTransaction } from "./credit-transaction.entity";

class CustomerCreditService {
  private getAccountRef(customerId: string) {
    return doc(application.getCollection("customer-accounts"), customerId);
  }

  private getTransactionRef(transactionId: string) {
    return doc(application.getCollection("credit-transactions"), transactionId);
  }

  async createDebtForSale(customerId: string, saleId: string, amount: number) {
    if (!customerId) throw new Error("Cliente obrigatório para venda fiado.");
    if (amount <= 0) throw new Error("Valor da dívida deve ser maior que zero.");

    const accountRef = this.getAccountRef(customerId);
    const transactionRef = this.getTransactionRef(v4());

    await runTransaction(firebase.db, async (transaction) => {
      const accountSnap = await transaction.get(accountRef);
      const currentBalance = accountSnap.exists()
        ? Number(accountSnap.data().balance || 0)
        : 0;

      transaction.set(accountRef, {
        customerId,
        balance: currentBalance + amount,
      });

      const creditTransaction = new CreditTransaction(
        transactionRef.id,
        customerId,
        saleId,
        "debt",
        amount,
        `Sale #${saleId}`
      );
      const { id, ...data } = creditTransaction.toObject();
      transaction.set(transactionRef, data);
    });
  }

  async registerManualPayment(customerId: string, amount: number) {
    if (!customerId) throw new Error("Cliente obrigatório.");
    if (amount <= 0) throw new Error("Informe um valor maior que zero.");

    const accountRef = this.getAccountRef(customerId);
    const transactionRef = this.getTransactionRef(v4());

    await runTransaction(firebase.db, async (transaction) => {
      const accountSnap = await transaction.get(accountRef);
      const currentBalance = accountSnap.exists()
        ? Number(accountSnap.data().balance || 0)
        : 0;

      if (amount > currentBalance) {
        throw new Error("Pagamento maior que o saldo devedor.");
      }

      transaction.set(accountRef, {
        customerId,
        balance: Math.max(0, currentBalance - amount),
      });

      const creditTransaction = new CreditTransaction(
        transactionRef.id,
        customerId,
        null,
        "payment",
        amount,
        "Manual payment"
      );
      const { id, ...data } = creditTransaction.toObject();
      transaction.set(transactionRef, data);
    });
  }

  async ensureAccount(customerId: string) {
    const accountRef = this.getAccountRef(customerId);
    await runTransaction(firebase.db, async (transaction) => {
      const accountSnap = await transaction.get(accountRef);
      if (accountSnap.exists()) return;
      const account = new CustomerAccount(customerId, customerId, 0);
      const { id, ...data } = account.toObject();
      transaction.set(accountRef, data);
    });
  }
}

export const customerCreditService = new CustomerCreditService();
